var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"equip-element"},[_c('div',{staticClass:"image mt-3",style:({ backgroundImage: 'url(' + _vm.image + ')' })}),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }